import { type NetworkOption, type StationNetworkConfig } from '../types';
import { deleteRequest, getRequest, postRequest } from './util';

export interface CreateStationNetworkConfigRequest {
  label: string;
  externalId: string;
  alias: string;
}

const get = async (stationId: number): Promise<StationNetworkConfig[]> =>
  await getRequest(`/stations/${stationId}/networkConfigs`);

const getNetworkOptions = async (stationId: number): Promise<NetworkOption[]> =>
  await getRequest(`/stations/${stationId}/networkConfigs/options`);

const create = async (
  stationId: number,
  request: CreateStationNetworkConfigRequest
): Promise<void> => await postRequest(`/stations/${stationId}/networkConfigs`, request);

const remove = async (stationId: number, stationNetworkConfigId: number): Promise<void> =>
  await deleteRequest(`/stations/${stationId}/networkConfigs/${stationNetworkConfigId}`);

export default {
  get,
  getNetworkOptions,
  create,
  remove,
};
